import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {BaseGlowColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-glow-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromAuraOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromAuraOfActiveItem';

export function ItemGlowColorPanel(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemGlowColor = useGetKeyFromAuraOfActiveItem('glowColor');

  if (!activeItem || !activeItemGlowColor) {
    throw new Error(`No active item`);
  }

  const updateGlowColor = (glowColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        aura: {
          glowColor,
        },
      },
      {undoable}
    );
  };

  return <BaseGlowColorPanel glowColor={activeItemGlowColor} onUpdateGlow={updateGlowColor} />;
}
